import React from 'react'

/**
 * @param isWebpEnabled
 * @param srcSet
 * @param isLazyLoading
 * @param extension
 * @returns {JSX.Element}
 * @constructor
 */
export function ImageWebP ({
  isLazyLoading,
  srcSet,
  extension,
  isWebpEnabled
}) {
  if (!isWebpEnabled) {
    return <></>
  }

  const webpSrcSet = srcSet.map(item =>
    item.replace(new RegExp(`${extension}(\\s\\d+w)$`), '.webp$1')
  )
  const props = {
    type: 'image/webp'
  }

  if (isLazyLoading) {
    props['data-srcset'] = webpSrcSet
  } else {
    props.srcSet = webpSrcSet
  }

  return <source {...props} />
}
